import { CometChat } from "@cometchat-pro/chat";
import axios from "axios";

const state = {
  unreadMessages: 0,
  IndiUnreadMessages: 0,
  unreadNotification: 0,
};
const getters = {
  unreadMessages: () => state.unreadMessages,
  IndiUnreadMessages: () => state.IndiUnreadMessages,
  unreadNotification: () => state.unreadNotification,
};
const actions = {
  async messagesHandler({ commit }) {
    try {
      const resp = await axios.get("user-notifications");
      const notif = resp.data.data.filter((i) => i.read_at == null);
      commit("setUnreadNotification", notif.length);
    } catch (error) {
      console.log(error, "~from state notification");
    }

    // console.log(notif.length)
  },
  async fetchUnreadMessages({ commit }) {
    await CometChat.getUnreadMessageCountForAllUsers().then(
      (array) => {
        // console.log("Message count fetched", array);
        commit("setIndiUnreadMessages", array);
        const arrUnreadAll = Object.values(array);
        commit(
          "setUnreadMessages",
          arrUnreadAll.reduce((a, b) => a + b, 0)
        );
      },
      (error) => {
        console.log("Error in getting message count", error);
      }
    );
  },
};
const mutations = {
  setUnreadMessages(state, data) {
    state.unreadMessages = data;
  },
  setIndiUnreadMessages(state, data) {
    state.IndiUnreadMessages = data;
  },
  setUnreadNotification(state, data) {
    state.unreadNotification = data;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
